import { Map, MapRef, Marker } from 'react-map-gl';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { forwardRef, useContext, useRef, useState } from 'react';
import CompaniesMapList from './CompaniesMapList/CompaniesMapList';
import CompanyMapPopup from './CompanyMapPopup/CompanyMapPopup';
import { SearchCompaniesOnMapContext } from '../SearchCompaniesOnMap.context';
import { MapCompany } from '../../../../../../types/api/endpoints/companies/allCompany.types';

export default forwardRef<MapRef, any>(
  (_, mapRef) => {
    const {
      entity,
      companies,
      isLoading,
  
      filters,
      setFilters,
  
      currentLocation
    } = useContext(SearchCompaniesOnMapContext)

    const markerRef = useRef<mapboxgl.Marker[]>([]);
  
    const [selectedCompany, setSelectedCompany] = useState<MapCompany>()
  
    const chooseCompany = (company: MapCompany) => {
      if (company.longitude && company.latitude) {
        // @ts-ignore
        mapRef.current?.setCenter([company.longitude * .999, company.latitude * 1.0002])
        // @ts-ignore
        mapRef.current?.setZoom(13)
        setSelectedCompany(company)
      }
    }

    const removeGeoFilters = () => {
      setFilters((value) => ({
        ...value,
        department: undefined,
        region: undefined
      }))
      // @ts-ignore
      mapRef.current?.setZoom(5)
      // @ts-ignore
      mapRef.current?.setCenter([-1.61878695312962, 47.8249046208979])
    }
  
    return (
      <Map
        ref={mapRef}
        mapboxAccessToken="pk.eyJ1IjoieWFjaW5lbGVucyIsImEiOiJjbGlvYjM2aHQwZTVzM2ZwY2RmbXhydjhxIn0.YVjskQUq6YwvpN2M14iVfg"
        initialViewState={{
          longitude: entity?.longitude,
          latitude: entity?.latitude,
          zoom: 13
        }}
        onZoom={(e) => {
          // console.log(e.viewState)
          const { zoom } = e.viewState
          // console.log('zoom', zoom)
          switch (true) {
            case (zoom < 10.5):
              if (filters.department) {
                setFilters((value) => ({
                  ...value,
                  department: undefined,
                  region: currentLocation?.region
                }))
              }
              return
            case (zoom > 10.5):
              if (filters.region) {
                setFilters((value) => ({
                  ...value,
                  department: currentLocation?.department,
                  region: undefined
                }))
              }
              return
          }
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          zIndex: 0,
          // visibility: searchValue && searchValue.length > 0 ? 'hidden' : 'visible'
        }}
        mapStyle="mapbox://styles/mapbox/streets-v9"
      >
        <div className='dashboard-companies__map-list-box'>
          <div className='dashboard-companies__map-list-container'>
            <CompaniesMapList
              {...{ companies, selectedCompany, chooseCompany, removeGeoFilters, isLoading }}
            />
          </div>
        </div>
        <CompanyMapPopup key={selectedCompany?.id_company} {...{ selectedCompany, setSelectedCompany }} />
        {(entity && entity.latitude && entity.longitude) &&
          <Marker
            // popup={popup} 
            longitude={entity.longitude}
            latitude={entity.latitude}
            color="#de5835"
          />
        }
        {companies?.results.map((company, index) => {
          const { latitude, longitude } = company
          if (latitude && longitude) {
            return (
              <Marker
                key={index}
                // popup={popup} 
                // @ts-ignore
                ref={ref => markerRef.current[index] = ref}
                longitude={longitude}
                latitude={latitude}
                color="#206c87"
                onClick={() => {
                  // console.log('company', company)
                  // markerRef.current[index].togglePopup()
                  chooseCompany(company)
                  // mapRef.current?.setCenter([longitude, latitude])
                }}
              />
            )
          } else {
            return null
          }
        })}
      </Map>
    )
  }
)